import styled from 'styled-components';

import { getPurpurColor, getPurpurSpacing, getPurpurTypography } from '@telialt/common-theme/src/purpurSelectors';

export const DescriptionContainer = styled.div`
    background-color: ${getPurpurColor('gray50')};
    font-size: ${getPurpurTypography('scale75')};
    padding: ${getPurpurSpacing('800')} 0 ${getPurpurSpacing('600')};
`;
